import React, { useState } from 'react'
import clsx from 'clsx'
import {
  FormControl,
  MenuItem,
  Select as MUISelect,
  FormHelperText,
  InputAdornment,
  IconButton,
  OutlinedInput,
  styled,
} from '@material-ui/core'
import useStyles from './FormFieldsStyle'
import { ReactComponent as AutocompleteIcon } from '../../../images/autocomplete-icon.svg'
const StyledPaper = styled('div')(({ theme }) => ({
  backgroundColor: '#4a4a4a',
  borderRadius: 8,
  boxShadow: theme.shadows[3],
}))

export default function Select({ field, values, setValues, errors }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  return (
    <FormControl
      className={clsx(
        classes.container,
        classes.customBorder,
        field.withMargin && classes.withMargin,
        field.withRightMargin && classes.withRightMargin
      )}
      variant="outlined"
      fullWidth={field.fullWidth}
    >
      <div id={`${field.id}-label`} className={classes.inputLabel}>
        {field.label}
      </div>
      <MUISelect
        labelId={`${field.id}-label`}
        id={field.id}
        value={values[field.key] || ''}
        fullWidth={field.fullWidth}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={
          field.onChange
            ? field.onChange
            : (event) => {
                delete errors[field.key]
                setValues({ ...values, [field.key]: event.target.value })
              }
        }
        name={field.key}
        displayEmpty
        MenuProps={{
          PaperProps: {
            component: StyledPaper, // Apply custom Paper component
          },
        }}
        error={errors && !!errors[field.key]}
        renderValue={
          field.renderValue
            ? field.renderValue
            : (selected) => {
                if (!selected) {
                  return (
                    <span
                      className={clsx(
                        classes.inputFont,
                        classes.selectPlaceholder
                      )}
                    >
                      {field.hint}
                    </span>
                  )
                }
                const selectedOption = field.options.find(
                  (option) => option.value === selected
                )
                return selectedOption?.label
              }
        }
        className={clsx(
          classes.customBorder,
          classes.selectHeight,
          classes.centerText
        )}
        input={
          <OutlinedInput
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  className={classes.iconButton}
                  style={{ marginRight: '10px' }}
                  onMouseDown={(event) => {
                    event.preventDefault()
                    setOpen((prevOpen) => !prevOpen)
                  }}
                >
                  <AutocompleteIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        }
        IconComponent={() => null}
      >
        {field.options.map((option) => (
          <MenuItem
            value={option.value}
            classes={{ root: classes.selectOption }}
          >
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
      {errors && errors[field.key] && (
        <FormHelperText className={classes.errorLabel}>
          {errors[field.key]}
        </FormHelperText>
      )}
    </FormControl>
  )
}
